import type { TableSortState } from '../UI';

// The name column's sort key, shared because the default sort below has to
// point at the same column `getInterventionRoomColumns` renders. A mismatch
// renders unsorted with nothing reported, so this and its test are the guard.
export const INTERVENTION_ROOM_NAME_COLUMN_KEY = 'name';

// Intervention rooms arrived in creation order, same as the patient rooms they
// sit beside (REH-301). Ordering is Danish for every user; see SORT_LOCALE.
export const DEFAULT_INTERVENTION_ROOMS_SORT: TableSortState = {
  key: INTERVENTION_ROOM_NAME_COLUMN_KEY,
  direction: 'asc'
};
